import styled from 'styled-components';
import { Select } from '@material-ui/core';

export const MetricsSelect = styled(Select)`
  min-width: 200px;
`;

export const MetricsComboBoxStyled = styled.div`
  padding: 20px;
  display: flex;
`;
